/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upsell_Not_On_PlanInputs */



/**
* | output |
* | --- |
* | "Not on this plan" |
*
* @param {Upsell_Not_On_PlanInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const upsell_not_on_plan = /** @type {((inputs?: Upsell_Not_On_PlanInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upsell_Not_On_PlanInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет в этом тарифе")
	return /** @type {LocalizedString} */ ("Not on this plan")
});